import { addToCartItem } from "@/utils/addTocart"
import { getProductsBySku } from "@/components/sharedCart/shareCartHelper"
import { isObjectEmpty } from "@/utils/"

import { store } from "@/store"
import { showPreviewCart } from "@/store/features/genericSlice"
import { addToCart, setCart } from "@/store/features/cartSlice"

import MissingImage from "@/public/images/image-missing.png"

export const getSlickSettings = () => {
  return {
    dots: false,
    draggable: true,
    touchMove: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    swipe: true,
    arrows: true,
    infinite: false,
    centerMode: false,
    focusOnSelect: false,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          dotsClass: "slider-dots",
          dots: true,
        },
      },
    ],
  }
}

export const getProductInfoQuickView = data => {
  const {
    brandName = "",
    productName = "",
    productDesc = "",
    skuID = "",
    category,
    pdpType,
    productPrice = 0,
    discountedPrice = 0,
    productImageUrl,
    productOnStock,
    selectedColor,
    categoryType,
    waterSenseProduct,
  } = data

  const waterSense = waterSenseProduct?.length > 0 ? true : false
  const productInfo = {
    category: categoryType,
    description: productDesc,
    frequency: "n/a",
    globalPromotionPrice:
      discountedPrice > 0
        ? Number((discountedPrice - 0).toFixed(2))
        : productPrice,
    globalOffer: "n/a",
    globalDiscount: Number(discountedPrice.toFixed(2)),
    isRecommended: "n/a",
    isSendNow: "n/a",
    isSubscription: "n/a",
    priceState: discountedPrice ? "discounted price" : "regular price",
    productBasePrice: Number(productPrice),
    productCategory: category,
    productColor: selectedColor,
    productCoupondiscount: "n/a",
    productCouponCode: "n/a",
    productID: skuID,
    productName: productName || productDesc || category || "n/a",
    productPartnerBuyNow: "n/a",
    productRoom: "product",
    productSalePrice:
      discountedPrice > 0
        ? Number((discountedPrice - 0).toFixed(2))
        : productPrice,
    productSaleable: true,
    productStatus: productOnStock > 0 ? "in stock" : "out of stock",
    productSuperSku: false,
    productTileName: productName,
    quantity: 1,
    defaultImageName: productImageUrl || "n/a",
    ratings: "n/a",
    numberOfReviews: "n/a",
    pdpType: pdpType || "regular finished goods & service parts",
    productFindingMethod: "n/a",
    productCollectionsName: productName,
    productBrand: brandName,
    itemType: "product",
    waterSenseProduct: waterSense,
  }
  return productInfo
}

export const formatProductInfoForAnalytics = (
  productInfoData,
  isMultifinishBundle = false,
  bundleInfo = {}
) => {
  if (!isMultifinishBundle) {
    return productInfoData
  }

  const {
    bundleIds = "",
    bundleProductColors = "",
    pdpType: bundlePdpType = "",
    bundlePrice = 0,
  } = bundleInfo

  return [
    {
      ...productInfoData,
      bundleIds,
      bundleProductColors,
      pdpType: bundlePdpType,
      bundlePrice,
    },
  ]
}

export const getSlickQuickViewPdpThumbnail = () => {
  return {
    dots: false,
    draggable: true,
    touchMove: true,
    slidesToScroll: 1,
    slidesToShow: 8.8,
    centerPadding: "10px",
    swipeToSlide: true,
    vertical: false,
    swipe: true,
    arrows: false,
    infinite: false,
    centerMode: false,
    focusOnSelect: false,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          draggable: true,
          touchMove: true,
          slidesToScroll: 1,
          slidesToShow: 4.8,
          centerPadding: "10px",
          vertical: false,
          swipe: true,
          centerMode: false,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 8,
          centerPadding: "10px",
          vertical: false,
          swipe: true,
          centerMode: false,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4.8,
          centerPadding: "10px",
          vertical: false,
          swipe: true,
          centerMode: false,
          swipeToSlide: true,
        },
      },
    ],
  }
}

export const getListValue = (arrayVal, stringVal, productData = []) => {
  if (productData[arrayVal]) {
    return productData[arrayVal]
  } else if (productData[stringVal]) {
    return [productData[stringVal]]
  } else {
    return []
  }
}

export const handleSpecsDownload = (e, title, link, productInfo = null) => {
  e.stopPropagation()
  let errMsg
  const url = link.trim()
  try {
    window.open(url, "_blank")
  } catch (err) {
    errMsg = err.message
    console.log(errMsg)
  }
}

export const organizeData = (data, name, placeHolder, type) =>
  data.map((item, i) => {
    let obj = {
      title: name ? name[i] : `${placeHolder} ${data.length > 1 ? i + 1 : ""}`,
    }
    if (type === "part") {
      obj = { ...obj, id: item }
    } else {
      obj = { ...obj, type, url: item }
    }
    return obj
  })

export const getInitialImageData = (labledImages = [], productSkuInit = "") => {
  const initialImagesData = []
  if (labledImages.length) {
    const index = labledImages
      .map(item => (item.split("|")?.length ? item.split("|")[0] : ""))
      .indexOf(productSkuInit)
    const assetId = labledImages[index]?.split("|")?.length
      ? labledImages[index].split("|")[1]
      : ""
    const imageParams = labledImages?.[index]?.split("|")
    const primaryImage = imageParams[imageParams.length - 1]
    initialImagesData.push({
      label: "",
      assetId,
      url: primaryImage ?? MissingImage?.src,
    })
  } else {
    initialImagesData.push({
      label: "",
      assetId: "",
      url: MissingImage?.src,
    })
  }
  return initialImagesData
}

// called when user click on Add To Cart button
export const handleAddToCart = async (
  e,
  selectedSku = "",
  brandName = "",
  cb = () => {}
) => {
  e.preventDefault()
  e.stopPropagation()
  const itemsProjectionApiResponse = await getProductsBySku([selectedSku])
  const variants = itemsProjectionApiResponse?.[0]?.variants ?? []
  variants.push(itemsProjectionApiResponse?.[0]?.masterVariant ?? {})
  let isComboSku = false

  for (const variant of variants) {
    if (selectedSku === variant.sku) {
      isComboSku = variant?.attributes.some(attr => attr.name === "ComboSKU")
    }
  }

  const payload = [
    {
      sku: selectedSku,
      quantity: 1,
      brand: brandName?.toLowerCase(),
      isBundle: isComboSku,
    },
  ]
  addToCartHandler(payload, cb)
}

// Api call to dispatch the item to the cart
export const addToCartHandler = async (items = [], cb = () => {}) => {
  const payload = await addToCartItem([...items])
  const body = {
    actions: payload,
  }

  store
    .dispatch(addToCart(body))
    .unwrap()
    .then(res => {
      const { payload = {} } = res
      if (!isObjectEmpty(payload)) {
        store.dispatch(setCart(payload))
      }
      cb()
      store.dispatch(showPreviewCart())
    })
    .catch(err => {
      cb()
    })
}

// if quickview modal open prevent scrollbar body top
export const preventPopupScroll = (isPopupClose = false) => {
  const bodyElement = document.body
  if (isPopupClose) {
    bodyElement.classList.remove("quickview-image-scroll")
  } else {
    bodyElement.classList.remove("modal-open", "scroll-lock")
    document
      .getElementsByTagName("html")[0]
      .classList.remove("modal-open", "scroll-lock")
    bodyElement.classList.add("quickview-image-scroll")
  }
}
